var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.509 0 0 114.496 0 256c0 141.489 114.496 256 256 256 141.491 0 256-114.496 256-256C512 114.509 397.504 0 256 0zm-7.575 375.819c-14.49 0-25.61-12.131-25.61-25.948 0-14.153 11.457-25.946 25.61-25.946 14.154 0 25.946 11.794 25.946 25.947 0 13.815-11.457 25.947-25.946 25.947zm38.414-131.083c-18.533 14.49-18.871 24.599-18.871 42.121 0 6.404-3.37 13.817-19.881 13.817-13.817 0-18.533-5.055-18.533-22.577 0-28.98 12.805-42.796 22.577-51.22 11.12-9.436 29.991-19.881 29.991-38.077 0-15.502-13.479-22.915-30.328-22.915-34.371 0-26.957 25.948-45.155 25.948-9.098 0-20.218-6.067-20.218-19.208 0-18.196 20.892-45.155 66.384-45.155 43.132 0 71.775 23.926 71.775 55.601s-28.643 54.589-37.741 61.665z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.a4800f40925a6a13c4e1dca790d054e1.svg";
export { ForwardRef as ReactComponent };